module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_029"
    }
  }, [_vm._v("This may seem confusing now, but don’t worry. As you go through the projects, it will make much more sense. Just remember to use layers of wool rather than a large clump to get the best results. And by keeping the fibers loose at one end, the surface area of the attachment place is increased and makes for a more secure attachment.")])]), _c('a', {
    attrs: {
      "id": "file_029"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d822712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_029.vue
// module id = 138
// module chunks = 0